import React, { useContext } from 'react';

import { AuthContext } from '../AuthContext';

import LoginForm from '../components/LoginForm';
import './Login.css';

export const Login = () => {

	const { activateAuth } = useContext(AuthContext);
	const visualStyle = {
		backgroundImage: `linear-gradient(135deg, rgba(14, 45, 91, 0.94), rgba(35, 83, 158, 0.84)), url('${process.env.PUBLIC_URL}/img/bg8.jpg')`
	};

	return (
		<main className="alex-login-page">
			<section className="alex-login-visual" style={visualStyle}>
				<div className="alex-login-visual-content">
					<div>
						<p className="alex-login-eyebrow">Production Workflow System</p>
						<img className="alex-login-hero-logo" src="img/alex_white_logo.png" alt="ALEX" />
						<p className="alex-login-copy">
							Printing orders, job orders, costing, reports, and approvals in one workspace.
						</p>
					</div>
					<div className="alex-login-metrics" aria-label="ALEX modules">
						<span>Printing Orders</span>
						<span>Job Orders</span>
						<span>Reports</span>
					</div>
				</div>
			</section>
			<section className="alex-login-panel" aria-label="Login form">
				<div className="alex-login-card">
					<div className="alex-login-card-header">
						<img src="img/alex_logo_cropped.png" alt="ALEX" />
						<p>Login to your account</p>
					</div>
					<LoginForm activateAuth={activateAuth} />
					<div className="alex-login-footer">
						<span>Powered by</span>
						<img src="img/vibal_logo.png" alt="Vibal" />
					</div>
				</div>
			</section>
		</main>
	);
};
